import { render } from "./CustomDatePicker.vue?vue&type=template&id=5252cae1&scoped=true&ts=true"
import script from "./CustomDatePicker.vue?vue&type=script&lang=ts"
export * from "./CustomDatePicker.vue?vue&type=script&lang=ts"

import "./CustomDatePicker.vue?vue&type=style&index=0&id=5252cae1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5252cae1"]])

export default __exports__